import React from 'react';
import store from 'javascripts/store.js';
import {observer} from 'mobx-react';

@observer
class TitleOptions extends React.Component {
  render() {
    return(
      <>
        <option value="">Title</option>
        {store.donateForm.titleOptions.map(title => (
          <option
            key={title}
            value={title}
          >
            {title}
          </option>
        ))}
      </>
    );
  }
}

export default TitleOptions;
